import apiInstance from "api";

// Sign-in options besides a typed password (flex2-api AuthController.SignInOptions.cs).
// The sign-in calls themselves (link redeem, set-password, PIN) go through
// redux-store/auth/actions loginUser(data, path), which stores the session.

export const checkSetPasswordLink = async (token) => {
  return await apiInstance.post("/auth/set-password/check", { token });
};

export const changePassword = async (body) => {
  return await apiInstance.post("/auth/change-password", body);
};

export const setDevicePin = async (body) => {
  return await apiInstance.post("/auth/pin", body);
};

export const listDevicePins = async () => {
  return await apiInstance.get("/auth/pin/devices");
};

// The second step of a sign-in with two-step verification on: the code texted or
// shown in the authenticator app, with the challenge the first step answered.
export const verifyTwoFactor = async (challenge, code) => {
  return await apiInstance.post("/auth/login/2fa", { challenge, code });
};

export const resendTwoFactorCode = async (challenge) => {
  return await apiInstance.post("/auth/login/2fa/resend", { challenge });
};

export const removeDevicePin = async (id) => {
  return await apiInstance.delete(`/auth/pin/devices/${id}`);
};
